import Navigation from '@/pages/home/components/Navigation';
import AboutHero from './components/AboutHero';
import BrandStory from './components/BrandStory';
import StoreLocation from './components/StoreLocation';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  return (
    <main className="min-h-screen font-sans">
      <Navigation />
      <AboutHero />
      <BrandStory />
      <StoreLocation />
      <Footer />
    </main>
  );
}
